import React, { Component } from 'react';
import {Dropdown} from 'react-bootstrap'

const tzApiValues = ["EST5EDT4", "CST6CDT5", "MST7MDT6", "PST8PDT7", "AKST9AKDT8", "HST10", "UTC"];
const unitDisplay = ["Eastern", "Central", "Mountain", "Pacific", "Alaska", "Hawaii", "UTC"];

export default class TZDropdown extends Component {
  constructor(props) {
    super(props);
    this.placeholder = ["Select one"];
  }
  render () {
    const active = tzApiValues.indexOf(this.props.value)
    const itemStyle = this.props?.itemStyle??"menu-item"
    return(
    <Dropdown>
      <Dropdown.Toggle className={this.props?.anchorStyle}>
        {typeof active === 'number' && active > -1 ? unitDisplay[active] : this.placeholder}
      </Dropdown.Toggle>
      <Dropdown.Menu>
        {unitDisplay.map((item, index) => 
          <Dropdown.Item className={itemStyle} key={index} 
             onClick={()=>this.props.onUpdate(tzApiValues[index])}>
            {item} 
          </Dropdown.Item>
        )}
      </Dropdown.Menu>
    </Dropdown>
    )
  }
}

export function tzDisplay (apiValue) {
  apiValue = apiValue ?? ''
  const found = tzApiValues.indexOf(apiValue)
  return found < 0 ? apiValue : unitDisplay[found]
}
